import { useEffect, useState } from "react"
import { FaWhatsapp } from "react-icons/fa"
import "../styles/components/wpsupport.style.css"
import { fetchGetDatawithID } from "../../lib/fetchGetDatawithID"

export function WhatsAppSupport() {
    const [whatsAppSupport, setWhatsAppSupport] = useState([])
    const id = "feujICDNSbtiliWy7onU"

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchGetDatawithID({collectionName: "whatsappsupport", id: id})
            setWhatsAppSupport(data)
        }
        fetchData()
    }, [])

    return (
        <>
            {whatsAppSupport.active &&
                <a
                    target="_blanck"
                    className="whatsapp-support"
                    href={`https://wa.me/55${whatsAppSupport.number}`}
                >
                    <FaWhatsapp />
                </a>
             }
        </>
    )
}